/** Component for sizeChart functions */
export function sizeChart(){
    var _THIS = this;
    this.elemContainer = null;
    this.init=function(elemcontainer){
        
        //updateFilterScroll(".collection-filter-section");
        checkFilters(".multipleSelection");
        registerEvents();

        $(".collection-filter-control, #filters-back, .filtersCat").click(function(){
            $(".size-chart-content").toggleClass("filtersShow");
            $(".size-chart-content").toggleClass("desktop");
            $("body").toggleClass("showModel"); 
        });

        sortVariantSize("#checkBoxes-brand");
        sortVariantSize("#checkBoxes-product_type");
        sortVariantSize("#checkBoxes-gender");
        sortVariantSize("#checkBoxes-age");
    }    

    function sortVariantSize(idd){ console.log(idd);
        /* Sort variants - Size */
        var ul = $(idd);
        var arr = $.makeArray(ul.children(".filter-label"));
    
        arr.sort(function(a, b) {
            var textA = +$(a).text();
            var textB = +$(b).text();
    
            if (textA < textB) return -1;
            if (textA > textB) return 1;
    
            return 0;
        });
    
        ul.empty();
        $.each(arr, function() {
            ul.append(this);
        });
    }

    var registerEvents  = function(){



        $(document).on("click",".collection-filter-item",function(e){ console.log($(this).data('waschecked'));
            if ($(this).data('waschecked') == true){
                $(this).prop("checked", false);
                $(this).data('waschecked', false);
                $(this).parents(".multipleSelection").find(".selectBox").removeClass("showCount"); 
            }else{ console.log("else");
                $(this).parents('.opened').find(".collection-filter-item").data('waschecked', false);
                $(this).data('waschecked', true);
                $(this).parents('.opened').find("input:checked").prop("checked", false);
                $(this).prop("checked", true);
                if(!$(this).hasClass('closeCheck')){ //console.log("click");
                    $(this).parents(".multipleSelection").find(".selectBox").addClass("showCount");
                }
            }
        })

        $(".clearLabel").click(function(){
            var idd = $(this).parent().attr("id"); 
            $("#"+idd+" .collection-filter-item").each(function(){
            $(this).prop("checked", false); 
            });   
            $("#"+idd).parents(".multipleSelection").find(".selectBox").removeClass("showCount"); 
            });
        
        $(".btn-search-filters").click(function(){
            var checked = 0;
            var count = 0;
            $(".multipleSelection .collection-filter-item").each(function(){
                if($(this).is(':checked') && !$(this).hasClass("closeCheck")){
                checked = 1;
                count += 1;
                }
            }); console.log(count);
            if(checked == 0){
            $(".chartMsg").fadeToggle();
            $('.redCount').css('display','none');
            $('.filterIcon').css('display','block');
            $(".sizechart-content").html(''); 
            }else{
                var brand = '';
                var product_type = '';
                var gender = '';
                var age = '';
                (async () => { 
                $("#checkBoxes-brand .collection-filter-item").each(function(){
                    if($(this).is(':checked')){
                        brand = $(this).val();
                    }
                });
                $("#checkBoxes-product_type .collection-filter-item").each(function(){
                    if($(this).is(':checked')){
                        product_type = $(this).val();
                    }
                });
                $("#checkBoxes-gender .collection-filter-item").each(function(){
                    if($(this).is(':checked')){
                        gender = $(this).val();
                    }
                });
                $("#checkBoxes-age .collection-filter-item").each(function(){
                    if($(this).is(':checked')){
                        age = $(this).val();
                    }
                });
            })();
                getSizeChart(brand, product_type, gender, age, count);
            }
            $(".chartMsg").delay(3000).fadeOut(1000,"linear",function(){
                if($(".chartMsg").is(':visible')){
                $(".chartMsg").fadeToggle();
                }
            })
        });

        

        $(document).on("click",".collection-filters-headings a.collection-filter-title",function(e){
            e.preventDefault();
            $(".collection-filters-headings li").removeClass("mobile-show")
            $(this).parent().addClass("mobile-show")
            var targetedDiv = $(this).attr("data-filter-section");
            $("." + targetedDiv).find("a.collection-filter-title").trigger("click")
            
        })



    }


    var getSizeChart = function(brand, product_type, gender, age, count){
        (async () => { console.log("testt");
        if(brand || product_type || gender || age){ 
            var str = makeid(8);
        $.ajax({
            type: 'GET',
            cache: false,
            headers: {
                'Cache-Control': 'max-age=0' 
            },
            url: window.Shopify.routes.root + 'pages/size-chart?view=size-chart-table&cache=false&brand='+brand+'&product_type='+product_type+'&gender='+gender+'&age='+age+'&type='+str,
            success: function(response) {
                console.log('reached');
                $(".sizechart-content").html(response);  
                $('.redCount').text(count);
                $('.redCount').css('display','block');
                $('.filterIcon').css('display','none');
                if($('.size-chart-content').hasClass("filtersShow")){
                $(".size-chart-content").toggleClass("filtersShow");
                $(".size-chart-content").toggleClass("desktop");
                $("body").toggleClass("showModel"); 
                }
            },
            error: function(status) {
                console.warn( 'ERROR', status );
            }
        })
    }
    })();
    }

    function makeid(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
          counter += 1;
        }
        return result;
    }


    var checkFilters = function(filtersection){


        var isAnyFilterSelected = false;
        var selectedFilterHTML = "";
        $(filtersection).each(function(){ 
            if($(this).find(".collection-filter-item:checked")){ 
                isAnyFilterSelected = true;
                    var getSelectedTag = encodeURIComponent($(this).find(".collection-filter-item:checked").attr("data-tag-type"))
                    if(getSelectedTag != 'undefined'){
                    $(this).find(".collection-filter-item:checked").parents(".multipleSelection").find('.selectBox').addClass("showCount");
                    console.log($(this).find(".collection-filter-item:checked").parent(".multipleSelection").find('.colFilter').attr('id'));
                    $(this).find(".collection-clear-filter").removeClass("hide")
                    $(this).find(".collection-clear-filter").find("a").attr("href",$(this).find(".collection-filter-item:checked").val())
                    $(this).find(".collection-filter-item").each(function(){
                            var getHref = $(this).attr("value"); 
                            if(getHref != undefined){
                            var nhref = getHref; 
                            //console.log(getHref)
                            //console.log(getSelectedTag+"+")
                            if (getHref.indexOf(getSelectedTag+"+")!==-1){ 
                                nhref =  getHref.replace(getSelectedTag+"+","")                                   
                            }else if(getHref.indexOf("+" + getSelectedTag)!==-1){
                                nhref =  getHref.replace("+" + getSelectedTag,"")                                   
                            }else if(getHref.indexOf(getSelectedTag)!==-1){
                                nhref =  getHref.replace( getSelectedTag,"")   
                            }
                            $(this).attr('value', nhref)

                            if($(this).hasClass("selected")){
                               //selectedFilterHTML +="<a href='3" +  $(this).find("a").attr("href")+ "'>"  + $(this).find("a").text() + "<span class='remove'></span></a>"
                            }
                        }

                    })
        }
        }

        })


    }
    
}

